const settings = {
  default: {
    showUserLocationControl: true,
    showRegionFitControl: true,
    showMarkerLegend: true,
    showRegionSearchControl: true,
    showPlacesSlectControl: false,
    hideMarkersOnLoad: true,
  },
  volunteerGroups: {
    showUserLocationControl: true,
    showRegionFitControl: false,
    showMarkerLegend: true,
    showRegionSearchControl: false,
    showPlacesSlectControl: true,
    hideMarkersOnLoad: false,
  },
}

export default settings;